import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { SimplifiedPrizesV2 as UISimplifiedPrizesV2 } from "@jti/loyalty/components/SimplifiedPrizes";

import type { simplifiedPrizesInputs } from "./SimplifiedPrizesV2.builder";

type SimplifiedPrizesBuilderProps = BuilderComponentProps<typeof simplifiedPrizesInputs>;

export const SimplifiedPrizesV2: FC<SimplifiedPrizesBuilderProps> = ({
  allFiltersData,
  physicalFiltersData,
  lotteryFiltersData,
  sensorialFiltersData,
  virtualFiltersData,
  additionalFiltersData,
  ...props
}) => {
  return (
    <UISimplifiedPrizesV2
      {...props}
      isInEditor={isEditing()}
      additionalFiltersData={additionalFiltersData}
      allFiltersData={{
        iconUrl: allFiltersData?.iconUrl ?? "",
        label: allFiltersData?.label ?? "All",
        isDisabled: allFiltersData?.isDisabled ?? false,
      }}
      physicalFiltersData={{
        iconUrl: physicalFiltersData?.iconUrl ?? "",
        label: physicalFiltersData?.label ?? "Physical",
        isDisabled: physicalFiltersData?.isDisabled ?? false,
      }}
      lotteryFiltersData={{
        iconUrl: lotteryFiltersData?.iconUrl ?? "",
        label: lotteryFiltersData?.label ?? "Lottery",
        isDisabled: lotteryFiltersData?.isDisabled ?? false,
      }}
      sensorialFiltersData={{
        iconUrl: sensorialFiltersData?.iconUrl ?? "",
        label: sensorialFiltersData?.label ?? "Sensorial",
        isDisabled: sensorialFiltersData?.isDisabled ?? true,
      }}
      virtualFiltersData={{
        iconUrl: virtualFiltersData?.iconUrl ?? "",
        label: virtualFiltersData?.label ?? "Virtual",
        isDisabled: virtualFiltersData?.isDisabled ?? false,
      }}
    />
  );
};
